import { createContext } from "react";
import { ThemeProps } from "../models/theme";
import {
  FALLBACK_PRIMARY,
  FALLBACK_SECONDARY,
  FALLBACK_TERTIARY,
} from "../config/theme";

export interface ThemeContextInterface {
  theme: ThemeProps;
  clearData: () => void;
  updateTheme: (data: ThemeProps) => void;
}

export const themeContextDefaults: ThemeContextInterface = {
  theme: {
    id: "0",
    url: "",
    url_type: "GROUP",
    color_primary: FALLBACK_PRIMARY,
    color_secondary: FALLBACK_SECONDARY,
    color_tertiary: FALLBACK_TERTIARY,
    light_gray: "#FCFCFC",
    logo_for_payment_portal: "",
    is_active: true,
  },
  clearData: () => {
    //function to clear Data
  },
  updateTheme: () => {
    //function to clear Data
  },
};

export const ThemeContext =
  createContext<ThemeContextInterface>(themeContextDefaults);
